<template>
    <pre-button
        v-bind="$attrs"
        :class="[
            colorClasses,
            'nio-button nio-button-blue nio-button-focus',
            'py-2 text-sm rounded shadow-md',
            iconOnly ? 'px-3' : 'px-4'
        ]"
        :disabled="disabled"
        :loading="loading"
        ref="button"
        v-on="$listeners"
    >
        <nio-spinner
            border-width="2"
            :inline="false"
            :light="color !== 'white'"
            :size="20"
            v-if="loading"
        />
        <span class="inline-flex justify-center items-center" :class="{ 'opacity-0': loading }">
            <nio-icon :class="iconClassName" :name="icon" v-if="icon" />
            <slot />
        </span>
    </pre-button>
</template>

<script>
    import { PreButton } from 'pre-ui';

    export default {
        components: { PreButton },

        props: {
            loading: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            color: {
                type: String,
                default: 'white',
            },
            icon: {
                type: String,
                default: '',
            },
            iconOnly: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            colorClasses() {
                switch (this.color) {
                    case 'white':
                        return 'text-gray-600 bg-white';
                    case 'blue':
                        return 'text-white active';
                    default:
                        return '';
                }
            },

            iconClassName() {
                switch (this.icon) {
                    case 'regular/add':
                    case 'regular/undo':
                        return 'mr-2 text-sm';
                    default:
                        return 'mr-2 text-base';
                }
            },
        },

        methods: {
            focus() {
                this.$refs.button.focus();
            },
        },
    };
</script>
